export default __webpack_public_path__ + "static/media/Caramel-Epoque-3.bf87000f.jpg";